/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/overview" />,
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401')),
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404')),
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/student-updates/:updateType',
        exact: true,
        component: lazy(() => import('src/views/StudentManagement/StudentUpdates/StudentUpdates')),
      },
      {
        path: '/subject-management',
        exact: true,
        component: lazy(() => import('src/views/SubjectManagement/subjectDetails.component')),
      },
      {
        path: '/subject-management/subject-details',
        exact: true,
        component: lazy(() => import('src/views/SubjectManagement/unitDetails.component')),
      },
      {
        path: '/subject-management/subject-details/topics',
        exact: true,
        component: lazy(() => import('src/views/SubjectManagement/topicsDetails.component')),
      },
      {
        path: '/subject-review',
        exact: true,
        component: lazy(() => import('src/views/SubjectReview')),
      },
      {
        path: '/user-management',
        exact: true,
        component: lazy(() => import('src/views/Users')),
      },
      {
        path: '/seo-manager',
        exact: true,
        component: lazy(() => import('src/views/SeoManager')),
      },
      {
        path: '/seo-manager/:action',
        exact: true,
        component: lazy(() => import('src/views/SeoManager/Form')),
      },
      {
        path: '/file-explorer',
        exact: true,
        component: lazy(() => import('src/views/FileExplorer')),
      },
      {
        path: '/transcoding-manager',
        exact: true,
        component: lazy(() => import('src/views/FileExplorer/TranscodingManager')),
      },
      {
        path: '/coupons',
        exact: true,
        component: lazy(() => import('src/views/Coupons')),
      },
      {
        path: '/marketing',
        exact: true,
        component: lazy(() => import('src/views/MarketingCampaign')),
      },
      {
        path: '/marketing/campaign',
        exact: true,
        component: lazy(() => import('src/views/MarketingCampaign/AddEditCampaign')),
      },
      {
        path: '/marketing/campaign/:id',
        exact: true,
        component: lazy(() => import('src/views/MarketingCampaign/AddEditCampaign')),
      },
      {
        path: '/scholarships/create',
        exact: true,
        component: lazy(() =>
          import('src/views').then(module => ({
            default: module.CreateScholarship,
          }))
        ),
      },
      {
        path: '/scholarship/edit/:id',
        exact: true,
        component: lazy(() =>
          import('src/views').then(module => ({
            default: module.EditScholarship,
          }))
        ),
      },
      {
        path: '/scholarships/:action?',
        exact: true,
        component: lazy(() =>
          import('src/views').then(module => ({
            default: module.ScholarshipDashboard,
          }))
        ),
        routes: [
          {
            path: '/scholarships/view',
            exact: true,
            component: lazy(() =>
              import('src/views').then(module => ({
                default: module.ViewScholarship,
              }))
            ),
          },
          {
            path: '/scholarships/verify',
            exact: true,
            component: lazy(() =>
              import('src/views').then(module => ({
                default: module.VerifyScholarship,
              }))
            ),
          },
          {
            path: '/scholarships/verify-non-scholarship',
            exact: true,
            component: lazy(() =>
              import('src/views').then(module => ({
                default: module.VerifyNonScholarship,
              }))
            ),
          },
          {
            path: '/scholarships/hall-tickets',
            exact: true,
            component: lazy(() =>
              import('src/views').then(module => ({
                default: module.HallTickets,
              }))
            ),
          },
          {
            path: '/scholarships/scholarship-type',
            exact: true,
            component: lazy(() => import('src/views/Scholarships/scholarshipType')),
          },
          {
            path: '/scholarships/document-type',
            exact: true,
            component: lazy(() => import('src/views/Scholarships/documentType')),
          },
        ],
      },
      {
        path: '/scholarship/verify/checkDocument/:id',
        exact: true,
        component: lazy(() =>
          import('src/views').then(module => ({
            default: module.CheckDocument,
          }))
        ),
      },
      {
        path: '/scholarship/hall-tickets/checkDocument/:id',
        exact: true,
        component: lazy(() =>
          import('src/views').then(module => ({
            default: module.CheckDocument,
          }))
        ),
      },
      {
        path: '/overview',
        exact: true,
        component: lazy(() =>
          import('src/views/Overview').then(module => ({
            default: module.OverviewComponent,
          }))
        ),
      },
      {
        path: '/publisher',
        exact: false,
        component: lazy(() =>
          import('src/views/Publisher').then(module => ({
            default: module.PublisherComponent,
          }))
        ),
        routes: [
          {
            path: '/publisher',
            exact: true,
            component: () => <Redirect to="/publisher/storeManager/storeDetails" />,
          },
          {
            path: '/publisher/storeManager/storelistings',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.StoreListingsComponent,
              }))
            ),
          },
          {
            path: '/publisher/catalogueManager/catalogueList',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.CatalogueListComponent,
              }))
            ),
          },
          {
            path: '/publisher/catalogueManager/createCatalogue',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.CreateCatalogueComponent,
              }))
            ),
          },
          {
            path: '/publisher/storeManager/storeDetailsList',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.StoreDetailsListComponent,
              }))
            ),
          },
          {
            path: '/publisher/storeManager/store',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.CreateStoreComponent,
              }))
            ),
          },
          {
            path: '/publisher/navigationManager/menu',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.NavigationManagerComponent,
              }))
            ),
          },
          {
            path: '/publisher/otsManager',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.OtsManagerComponent,
              }))
            ),
          },
          {
            path: '/publisher/editOts',
            exact: true,
            component: lazy(() =>
              import('src/views/Publisher').then(module => ({
                default: module.OtsEditComponent,
              }))
            ),
          },
        ],
      },
      {
        path: '/legal',
        exact: true,
        component: lazy(() => import('src/views/legal')),
      },
      {
        path: '/faculty-reports',
        exact: true,
        component: lazy(() => import('src/views/FacultyReports')),
      },
      {
        path: '/deliveryManagement',
        exact: true,
        component: lazy(() => import('src/views/DeliveryManagement')),
      },
      {
        path: '/student-management',
        exact: true,
        component: lazy(() => import('src/views/StudentManagement/CustomerSupportManagement')),
      },
      {
        path: '/student-management/:studentId',
        exact: true,
        component: lazy(() =>
          import('src/views/StudentManagement/CustomerSupportManagement/StudentInfo')
        ),
      },
      {
        path: '/live-classes',
        exact: true,
        component: lazy(() => import('src/views/StudentManagement/LiveClasses/LiveClasses')),
      },
      {
        path: '/live-classes/insights',
        exact: true,
        component: lazy(() => import('src/views/StudentManagement/LiveClasses/Insights')),
      },
      {
        path: '/go-live',
        exact: true,
        component: lazy(() => import('src/views/StudentManagement/LiveClasses/GoLive')),
      },
      {
        path: '/batch-management',
        exact: true,
        component: lazy(() => import('src/views/BatchManagement')),
      },
      {
        path: '/group-management',
        exact: true,
        component: lazy(() => import('src/views/GroupManagement')),
      },
      {
        path: '/batch-management/students',
        exact: true,
        component: lazy(() => import('src/views/BatchManagement/Students')),
      },
      {
        path: '/payment-invoices',
        exact: true,
        component: lazy(() => import('src/views/FinanceDashboard')),
      },
      {
        path: '/web-banner',
        exact: true,
        component: lazy(() => import('src/views/BannerUpdate/Website')),
      },
      {
        path: '/mobile-banner',
        exact: true,
        component: lazy(() => import('src/views/BannerUpdate/Mobile')),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
];
